import { ModalView, useModalView } from '@/design-system/components/modal';
import { NativeModalView } from '@/design-system/components/modal/nativeModal/NativeModalView';
import { useNativeModalView } from '@/design-system/components/modal/nativeModal/useNativeModalView';
import { LayoutContext } from 'contexts/LayoutContext';
import { useContext } from 'react';

interface ModalContainerViewProps {
  dimensions: {
    height: number;
    width: number;
  };
}

export const ModalContainerView: React.FC<ModalContainerViewProps> = ({ dimensions, children }) => {
  const layout = useContext(LayoutContext);

  if (layout.isMobile) {
    const { animatedStyle, handleBack } = useNativeModalView({});
    return (
      <NativeModalView animatedStyle={animatedStyle} onBack={handleBack} showHeader={false}>
        {children}
      </NativeModalView>
    );
  }

  const modal = useModalView({ dimensions });

  return <ModalView {...modal}>{children}</ModalView>;
};
